/**
 * Service provider for PouchDB *
 * @name pouch-service.ts
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Injectable, NgZone } from '@angular/core';
declare var require: any;
import PouchDB from 'pouchdb';
const utils = require('relational-pouch/lib/pouch-utils.js');
utils.Promise = window.Promise;
PouchDB.plugin(require('relational-pouch'));
PouchDB.plugin(require('pouchdb-find'));
//PouchDB.plugin(require('relational-pouch'));
require('pouchdb-all-dbs')(PouchDB);
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
declare let firebase: any;
import Analytics from 'analytics';
declare let Tawk_API: any;
import googleAnalytics from '@analytics/google-analytics';
const { htmlToText } = require('html-to-text');
const pluralize = require('pluralize');
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable, Observer, fromEvent, merge } from 'rxjs';
import { Printer, PrintOptions } from '@awesome-cordova-plugins/printer/ngx';
import { last, map } from 'rxjs/operators';
import { LoadingController, Platform, ToastController } from '@ionic/angular';
import moment from 'moment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PouchService {
  analytics = Analytics({
    app: 'sarutech.com',
    plugins: [
      googleAnalytics({
        measurementIds: [environment.analytics],
      }),
    ],
  });
  tawk = Tawk_API;
  health_systems = ['patient', 'pharmacy', 'hospital', 'ward', 'bed', 'prescription', 'laboratory', 'radiology'];
  public db;
  languages: any[] = [
    { code: 'en', name: 'English' },
    { code: 'zh', name: '中文 (zhōngwén)' },
    { code: 'hi', name: 'हिन्दी (hindī)' },
    { code: 'es', name: 'español [espaˈɲol]' },
    { code: 'fr', name: 'français [fʁɑ̃sɛ]' },
    { code: 'ar', name: '(al arabiya) العربية' },
    { code: 'ru', name: 'Русский язык (Russkij jazyk)' },
    { code: 'pt', name: 'português' },
    { code: 'pl', name: 'polski' },
    { code: 'nl', name: 'Nederlands' },
    { code: 'ja', name: '日本語 (nihongo)' },
    { code: 'it', name: 'italiano' },
    { code: 'tr', name: 'Türkçe' },
    { code: 'ko', name: '한국어 [韓國語] (han-guk-eo)' },
    { code: 'de', name: 'Deutsch [dɔʏtʃ]' },
  ];
  remote: any;
  private pendingSync: Promise<any>;
  pages = [];
  credentials = null;
  online = true;
  connected = false;
  gsetting: any = {
    startdate: null,
    expiredate: null,
  };
  testdb_available = false;
  untranslated = [];
  user: any;
  demo = false;
  showback = true;
  headers;
  translations;
  triedregister = false;
  reconnected = false;
  syncHandler;
  language = 'en';
  data: any = {};
  replications_pending = 0;
  replications_total = 1;
  loading;
  user_roles: any = {};
  conflicted_documents = [];
  currencies = [];
  showpages = false;
  pendingtasks = 0;
  preloaded = false;
  previous_route = null;
  loaded_previous_route = false;
  reference = null; // file reference for copy and paste functions
  unreadmessages: any = {
    //keep track of unread messages
    total: 0,
  };
  schema;
  appinfo;
  userinfo: any = {
    country_code: 'US',
  };
  server_url = 'https://sarutech.com/api';
  local_server_url = 'http://localhost:3000/api';
  homelogo;
  businessAccounts: any = {};
  subscriptions: any = {};
  alternativeRemote: any;
  defaultRemote: any;
  defaultDB = true;
  alternativeSyncHandler: any;
  defaultSyncHandler: any;
  changes: any = {}; //Behavioural Subject to record updated entity that may cause document update conflict
  /**
   * Constructor
   */
  constructor(public http: HttpClient, public loadingCtrl: LoadingController, private router: Router, private zone: NgZone, public platform: Platform, public toastController: ToastController, private printer: Printer) {
    this.headers = new HttpHeaders().append('Content-Type', 'application/json').append('Access-Control-Allow-Origin', '*');
    this.fetchLocalSchema('').then(async (data: any) => {
      let schema_array = [];
      let settings = [`setting_2_${this.gsetting.id}`];
      let preload_array = [];
      data.schema.map((schema) => {
        schema_array.push(schema.singular);
        settings.push(`setting_2_${schema.singular}`);
        if (schema.preload != undefined && schema.preload == true) {
          preload_array.push(schema.singular);
        }
      });
      this.appinfo = {
        id: Math.round(new Date().getTime()).toString(),
        rev: '',
        username: '',
        platform: '',
        filtered: localStorage.getItem(environment.product) != null, // identified if the app instance should be treated as a filtered replication
        base_product: environment.product,
        title: environment.title,
        product: localStorage.getItem(environment.product) == null ? environment.product : localStorage.getItem(environment.product), //can be set by the user now
        schema_array: schema_array,
        preload_array: preload_array,
        settings: settings,
        filter_function: {
          _id: '_design/replication',
          filters: {
            by_schema_array: 'function(doc, req) {\n                        return doc._id === "_design/replication" || req.query.schema_array.includes(doc._id.substring(0, doc._id.indexOf("_2_"))) || req.query.settings.includes(doc._id);\n                    }',
            language: 'javascript',
          },
        },
        token: '',
        homecomponent: environment.homecomponent,
        version: environment.version,
        setup: false, //indicate that it is this is setup
      };
      this.getJSON('./assets/data/currencies.json').subscribe((data) => {
        this.currencies = data;
      });
      this.checkTestDB();
      if (localStorage.getItem('language') != null) {
        this.language = localStorage.getItem('language');
      }
    });
  }

  addToBusinessAccounts() {
    if (this.gsetting.username != undefined) {
      let currentAccounts = JSON.parse(localStorage.getItem(`${this.appinfo.base_product}_accounts`));
      if (currentAccounts == null) {
        currentAccounts = {};
      }
      currentAccounts[this.gsetting.username] = {
        gsetting: this.gsetting,
        user: this.user,
      };
      localStorage.setItem(`${this.appinfo.base_product}_accounts`, JSON.stringify(currentAccounts));
      this.businessAccounts = currentAccounts;
    } else {
      console.log('no gsetting');
    }
  }

  /**
   * Initialize PouchDB database
   */
  initDB(credentials, start = false, defaultDB = true) {
    this.db = new PouchDB(this.appinfo.product + '$' + credentials.user_id, {
      skip_setup: credentials.skip_setup,
    });
    this.defaultDB = defaultDB;
    this.credentials = credentials;
    if (this.defaultDB) {
      localStorage.setItem(this.appinfo.product + '_credentials', JSON.stringify(credentials));
      //subsscription event that will update this.online variable when internet status changes
      this.onlineCheck$().subscribe((online) => {
        console.log(online);
        if (!this.online && online && credentials.online) {
          this.login(); //enable syncing once internet comes, if user has a valid license;
        }
        if (online && !this.userinfo.ip_address) {
          this.getUserInfo();
        }
        this.online = online;
      });
    }
    return this.setStructure(start).then(async (msg) => {
      //enable syncing if user has a valid license
      if (credentials.online || !this.defaultDB) {
        this.enableSyncing(credentials);
      }
      this.get(credentials.user_id, 'setting').then(async (setting) => {
        if (setting != undefined || !this.defaultDB) {
          if (setting) {
            this.gsetting = setting;
          }
          this.addToBusinessAccounts();
          //set demo
          if (this.gsetting.id == this.appinfo.product + 'test' && location.hostname != 'localhost') {
            this.demo = true;
            this.gsetting.currency = this.userinfo.currency || '₦';
          }

          if (this.gsetting.expiredate == undefined) {
            //if no expiration date
            if (this.gsetting.plans[this.gsetting.plans.length - 1] == 'free') {
              //if he is a free user, give him 7 days
              this.setExpire(7, 'days');
            } else {
              // if he has a license, give him 1 year
              this.setExpire(12);
            }
          }
          // set home logo
          if (this.gsetting.attachments != undefined && this.gsetting.attachments.logo != undefined && this.gsetting?.home_page_custom_logo && (this.getPlan() == 'standard' || this.getPlan() == 'enterprise')) {
            this.getAttachment('setting', this.gsetting.id, 'logo').then((file) => {
              this.blobToDataURL(file, (dataurl) => {
                this.homelogo = dataurl;
              });
            });
          }
          //if license expires or free user, disable syncing
          if (((credentials.online || !this.defaultDB) && new Date() > new Date(this.gsetting.expiredate)) || this.gsetting.plans[this.gsetting.plans.length - 1] == 'free') {
            // stop syncing if expired license or a free user
            credentials.online = false;
            this.connected = false; //record disconnect
            localStorage.setItem(this.appinfo.product + '_credentials', JSON.stringify(credentials));
            if (this.syncHandler != undefined) {
              this.syncHandler.cancel();
            }
          } else if (!this.connected && this.defaultDB) {
            //try to connect, if it is disconnected for any reason
            await this.login();
          }
        } else {
          console.log('no gsetting');
        }
        // update schema array with data from the server / db
        let newschema = await this.get('schema', undefined);
        let schema_array = [];
        newschema.schema.map((schema) => {
          schema_array.push(schema.singular);
        });
        this.appinfo.schema_array = schema_array;
      });
    });
  }

  blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function (e) {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  }

  createIndex(index) {
    this.db
      .createIndex({
        index: {
          fields: [index],
        },
      })
      .then(function (result) {
        console.log('Conflict index created');
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  async getDeletedDocuments(): Promise<any> {
    let ids = await this.deletedDocIds();
    const results = await Promise.all(
      ids.map(async (id) => {
        try {
          // Get the revision history of the document
          const revHistory = await this.db.get(id, { revs: true, open_revs: 'all' });
          if (revHistory[0].ok) {
            const revs = revHistory[0].ok._revisions.ids;
            const start = revHistory[0].ok._revisions.start;

            // Iterate through the revisions to find the latest one with actual document content
            for (let i = 1; i < revs.length; i++) {
              const rev = `${start - i}-${revs[i]}`;
              try {
                const doc = await this.db.get(id, { rev });
                if (doc) {
                  return doc;
                }
              } catch (error) {
                if (error.status === 404) {
                  // Continue to the next revision if not found
                  continue;
                } else {
                  throw error;
                }
              }
            }
          }
          return null;
        } catch (error) {
          console.error('Error retrieving document revision:', error);
          return null;
        }
      })
    );

    // Filter out null values
    return results.filter((doc) => doc !== null && doc.data);
  }

  deletedDocIds(): Promise<string[]> {
    const ret: string[] = [];
    return new Promise((resolve, reject) => {
      this.db
        .changes({ filter: (d) => d._deleted })
        .on('change', (c) => ret.push(c.id))
        .on('complete', () => resolve(ret))
        .on('error', (e) => reject(e));
    });
  }

  async deletedDocs() {
    const ids = await this.deletedDocIds();
    return Promise.all(
      ids.map((id) =>
        this.db.get(id, { revs: true, open_revs: 'all' }).then((x) => {
          const revs = (x[0].ok as any)._revisions;
          const lastRev = revs.start - 1 + '-' + revs.ids[1];
          return this.db.get(id, { rev: lastRev }); // with Pouchdb keys too
        })
      )
    );
  }

  getConflicts(): Promise<any> {
    return this.db
      .allDocs({
        include_docs: true,
        conflicts: true,
      })
      .then((docs) => {
        docs = docs.rows.filter((d) => d.doc._conflicts != undefined && (d.doc._id == this.gsetting.username || !d.doc._id.startsWith('setting')) && d.doc._id != 'schema');
        return docs.map((e: any) => e.doc);
      });
  }

  setStructure(update = false) {
    let doc: any = {};
    let rev = '';
    return this.get('schema', undefined)
      .then(async (ddoc) => {
        //schema is available, get rev
        doc = ddoc;
        rev = ddoc._rev;
        if (update) {
          //reset schema on update
          await this.resetSchema(rev).then((res) => {
            doc = res;
          });
        }
      })
      .catch(async (err) => {
        //schema not available. define schema
        update = true; // if not found then treat as first time
        await this.resetSchema(rev).then((res) => {
          doc = res;
        });
      })
      .finally(() => {
        this.db.setSchema(doc.schema);
        if (update && !this.appinfo.filtered) {
          return this.resetSettings(doc).then((msg) => {
            return this.update(doc, undefined).then((d) => {}); // update schema last
          });
        }
      });
  }

  async resetSchema(rev = '') {
    return new Promise(async (resolve, reject) => {
      if (this.online && this.testdb_available) {
        let data = {
          id: 'schema',
          database: `${this.appinfo.product}$${this.appinfo.product}test`,
          filter: this.appinfo.schema_array,
        };
        this.http.post('https://sarutech.com/api/app/cloneSchema', data).subscribe(
          (res) => {
            let doc: any = res;
            doc._rev = rev;
            resolve(doc);
          },
          async (err) => {
            let schema = await this.fetchLocalSchema(rev);
            resolve(schema);
          }
        );
      } else {
        let schema = await this.fetchLocalSchema(rev);
        resolve(schema);
      }
    });
  }

  resetSettings(doc) {
    return new Promise((resolve, reject) => {
      // get old settings
      return this.getAll('setting').then(async (oldsettings) => {
        //get new settings
        let newsettings: any = [];
        if (this.online && this.testdb_available) {
          let data = {
            database: `${this.appinfo.product}$${this.appinfo.product}test`,
            schema: doc,
          };
          await this.http.post('https://sarutech.com/api/app/cloneSettings', data).subscribe(
            async (res) => {
              newsettings = res;
              resolve(await this.completeResetSettings(oldsettings, newsettings, doc));
            },
            async (err) => {
              newsettings = await this.fetchLocalSettings().toPromise();
              resolve(await this.completeResetSettings(oldsettings, newsettings, doc));
            }
          );
        } else {
          newsettings = await this.fetchLocalSettings().toPromise();
          newsettings = newsettings.filter((setting) => this.appinfo.schema_array.includes(setting.id));
          resolve(await this.completeResetSettings(oldsettings, newsettings, doc));
        }
      });
    });
  }

  async completeResetSettings(oldsettings, newsettings, doc) {
    //delete old settings not in schema to avoid errors from db incase these settings were not deleted
    let credentials = JSON.parse(localStorage.getItem(this.appinfo.product + '_credentials'));
    /* await oldsettings.map(async (oldsetting) => {
      if (doc.schema.filter((e) => e.singular == oldsetting.id).length < 1 && oldsetting.id != credentials.user_id) {
        await this.remove(oldsetting, 'setting');
      }
    }); */
    // Add only new settings that are not in old settings
    const additionalsettings = newsettings.filter((setting) => {
      // Check if the current item is not in oldsettings
      return !oldsettings.some((elem) => elem.id === setting._id);
    });
    // save additional settings
    return Promise.all(
      additionalsettings.map(async (setting) => {
        this.update(setting, 'setting');
      })
    ).then((res) => {
      return true;
    });
  }

  async initializeFiterFunction() {
    return new Promise((resolve, reject) => {
      this.getJSON('./assets/data/filter.json').subscribe(
        async (data) => {
          await this.update(data, undefined);
          resolve(data); // Resolving the promise with the modified schema object
        },
        (error) => {
          reject(error); // Rejecting the promise in case of an error
        }
      );
    });
  }

  async fetchLocalSchema(rev) {
    return new Promise((resolve, reject) => {
      this.getJSON('./assets/data/schema.json').subscribe(
        (data) => {
          let schema = data;
          schema._rev = rev;
          schema._id = schema.id;
          resolve(schema); // Resolving the promise with the modified schema object
        },
        (error) => {
          reject(error); // Rejecting the promise in case of an error
        }
      );
    });
  }

  fetchLocalSettings(): Observable<any> {
    return this.getJSON('./assets/data/settings.json');
  }

  async newSystemSetting(credentials, user: any = {}) {
    await this.initializeFiterFunction(); // initialize filter function
    let setting = {
      id: credentials.user_id,
      rev: '',
      company: user.name != undefined ? user.name : '',
      contactname: user.name != undefined ? user.name : '',
      username: credentials.user_id,
      password: credentials.password,
      address: '',
      country: user.country != undefined ? user.country : '',
      phone: user.phonenumber != undefined ? user.phonenumber : '',
      email: user.email != undefined ? user.email : '',
      receiptmessage: 'Thanks for shopping with us',
      startdate: new Date().toUTCString(),
      expiredate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
      online: credentials.online,
      currency: this.userinfo.currency || '$',
      currency_code: this.userinfo.currency_code || 'USD',
      qrcode: true,
      pos_print: false,
      logo: '',
      plans: ['free'],
      expire_alert_days: 30,
      showtip: true,
      sale_tax: 0,
      tax_identification_number: '',
      tax_percentage: 0,
      vonage_api_key: '',
      vonage_api_secret: '',
      appointment_duration: 30,
      trackchanges: false,
    };
    return this.update(setting, 'setting').then((res) => {
      return setting;
    });
  }

  databaseExist(db): Promise<boolean> {
    return PouchDB.allDbs().then((dbs) => {
      return dbs.indexOf(db) != -1;
    });
  }

  async handleSyncEvents(syncHandler, source) {
    let mythis = this;
    syncHandler
      .on('change', function (info) {
        if (info.change && mythis.loading) {
          if (info.change.pending !== undefined && info.change.docs_read !== undefined) {
            mythis.replications_total = info.change.pending + info.change.docs_read;
          }
          if (info.change.pending !== undefined) {
            mythis.replications_pending = info.change.pending;
            mythis.loading.message = `Synchronizing Database (${((mythis.replications_total - mythis.replications_pending) / mythis.replications_total) * 100}%) Complete`;
          }
        }
        console.log(`Sync changed (${source})`);
      })
      .on('complete', function () {
        console.log(`Sync complete (${source})`);
      })
      .on('error', function (err) {
        if (!mythis.reconnected && new Date() <= new Date(mythis.gsetting?.expiredate)) {
          mythis.login();
        } else {
          console.log(`Offline (${source})`);
          mythis.connected = false;
        }
      });
  }

  async enableSyncing(credentials) {
    let signature = await this.getSignature();
    if (signature == this.gsetting.signature || this.gsetting.alternative_db == undefined) {
      let options: any = {
        Auth: this.gsetting.alternative_db?.username ? this.gsetting.alternative_db : this.lauth,
        live: true,
        retry: true,
        continuous: true,
      };
      if (this.appinfo.filtered) {
        // add query parameters for cases with filtered replication
        options.filter = 'replication/by_schema_array';
        options.query_params = {
          schema_array: this.appinfo.schema_array,
          settings: this.appinfo.settings,
        };
      }
      if (credentials.userDBs != undefined || this?.gsetting?.alternative_db?.username != '') {
        this.alternativeRemote = this.gsetting?.alternative_db && this.gsetting?.alternative_db?.username !== '' ? `http://${this?.gsetting?.alternative_db?.username}:${encodeURIComponent(this?.gsetting?.alternative_db?.password)}@${this?.gsetting?.alternative_db?.ip}:${this?.gsetting?.alternative_db?.port}/${this?.gsetting?.alternative_db?.database}` : null;

        this.defaultRemote = credentials?.userDBs?.[this.appinfo.product];

        if (this.defaultRemote || this.alternativeRemote) {
          this.connected = this.online ? true : false; // Record connection status
          const syncOptions = {
            live: true,
            retry: true,
          };
          if (this.defaultRemote) {
            // Sync to Default database (Always enabled)
            this.defaultSyncHandler = this.db.sync(this.defaultRemote, syncOptions);
            this.handleSyncEvents(this.defaultSyncHandler, 'Defult DB');
          }
          if (this.alternativeRemote) {
            // Sync to Alternative database (Only if username is not empty)
            this.alternativeSyncHandler = this.db.sync(this.alternativeRemote, syncOptions);
            this.handleSyncEvents(this.alternativeSyncHandler, 'Alternative DB');
          }
        } else {
          localStorage.removeItem(this.appinfo.product + '_credentials');
        }
      } else {
        if (!this.reconnected && new Date() <= new Date(this.gsetting.expiredate) && this.gsetting.plans[this.gsetting.plans.length - 1] != 'free') {
          //try to reconnect to server once
          this.login();
        } else {
          // show diconnect error
          //console.log(!mythis.reconnected, (new Date() <= new Date(mythis.gsetting.expiredate)));
          console.log('offline');
          this.connected = false;
        }
      }
    } else if (this.gsetting.username != undefined) {
      this.presentToastAction('Your license is invalid. Please do not tamper with the license details', 'toast-danger', 'Repair');
    }
  }

  async loadDefaultDb(credentials): Promise<boolean> {
    if (credentials.online) {
      let options: any = {
        Auth: this.lauth,
      };
      if (this.appinfo.filtered) {
        // add query parameters for cases with filtered replication
        options.filter = 'replication/by_schema_array';
        options.query_params = {
          schema_array: this.appinfo.schema_array,
          settings: this.appinfo.settings,
        };
        try {
          await this.db.put(this.appinfo.filter_function);
        } catch (error) {
          console.log(error);
        }
      }
      this.remote = credentials.userDBs[this.appinfo.product];
      return (this.syncHandler = this.db
        .sync(this.remote, options)
        .on('change', function (change) {
          console.log(change);
          //return true;
        })
        .on('complete', function (complete) {
          return true;
        })
        .on('error', function (err) {
          console.log(err);
        }));
    }
  }

  async repairLicense() {
    const customer: any = await this.http.post('https://sarutech.com/api/app/getCustomer', { email: this.gsetting.email }).toPromise();
    if (customer?.data?.databases?.[`${this.appinfo.product}$${this.gsetting.username}`]?.license != undefined) {
      this.gsetting.startdate = customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`].license.startdate;
      this.gsetting.expiredate = customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`].license.expiredate;
      this.gsetting.signature = customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`].license.signature;
      this.gsetting.plans = customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`].license.plan;
      this.gsetting.restrictions = customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`].license.restrictions;
      await this.update(this.gsetting, 'setting');
      this.enableSyncing(this.credentials);
      this.presentToastAction('License repaired successfully', 'toast-success', 'Close');
    }
  }

  async getSignature(): Promise<string> {
    let data = {
      username: this.gsetting.username,
      plan: this.gsetting.plans,
      startdate: this.gsetting.startdate,
      expiredate: this.gsetting.expiredate,
      restrictions: this.gsetting.restrictions,
    };
    const jsonString = JSON.stringify(data, Object.keys(data).sort());
    const key = await crypto.subtle.importKey('raw', new TextEncoder().encode(environment.signKey), { name: 'HMAC', hash: { name: 'SHA-256' } }, false, ['sign']);
    const signature = await crypto.subtle.sign('HMAC', key, new TextEncoder().encode(jsonString));
    return btoa(String.fromCharCode(...new Uint8Array(signature)));
  }

  validateUsername(username) {
    return this.http.get('https://sarutech.com/couchdblogin/' + 'auth/validate-username/' + username);
  }

  save(data: any, type: any): Promise<any> {
    if (data.id == '') {
      data.id = Math.round(new Date().getTime()).toString();
    }

    return this.db.rel
      .save(type, data)
      .then((data: any) => {
        if (this.gsetting.logs_enabled) {
          this.log(data, 'added', type);
        }
        if (data && this.retrieve(data, type) && this.retrieveFirst(data, type)) {
          return this.retrieveFirst(data, type);
        } else {
          return data;
        }
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  log(data, action, type) {
    if (type != 'log' && type != 'setting' && type != 'schema') {
      let log = {
        id: Math.round(new Date().getTime()).toString(),
        date: new Date().toISOString(),
        action: action,
        entity: type,
        entity_id: data?.id,
        entity_name: data?.name || data?.title || data.customer_name || data?.id,
        customer: data?.customer,
        customer_name: data?.customer_name,
        user: this.user?.id,
        user_type: 'user',
        user_name: this.user?.fullname,
        ip_address: this.userinfo?.ip_address,
        device: this.userinfo?.device,
        location: this.userinfo?.city + ', ' + this.userinfo?.country,
      };
      this.save(log, 'log');
    }
  }

  //get ip address
  async getUserInfo() {
    this.http.get('https://api.ipify.org/?format=json').subscribe((ip) => {
      this.userinfo['ip_address'] = ip['ip'];
      this.http.get(`https://ipapi.co/${this.userinfo.ip_address}/json/`).subscribe((location) => {
        this.userinfo['city'] = location['city'];
        this.userinfo['country'] = location['country_name'];
        this.userinfo['country_code'] = location['country_code'];
        this.userinfo['country_calling_code'] = location['country_calling_code'];
        this.userinfo['language'] = location['languages'].split(',')[0];
        this.userinfo['currency'] = this.currencies[location['currency']];
        this.userinfo['currency_code'] = location['currency'];
        this.userinfo['timezone'] = location['timezone'];
        if (this.userinfo.language != undefined && localStorage.getItem('language') == undefined) {
          // Set the language based on user info
          const userLang = this.userinfo['language'].split('-')[0];
          const lang = this.languages.find((l) => l.code === userLang);
          this.language = lang ? userLang : 'en'; // default to English if language is not in the list
        }
      });
    });
    this.userinfo['device'] = this.platform.platforms();
  }

  update(data, type): Promise<any> {
    if (type == undefined) {
      return this.db
        .put(data)
        .then((doc) => {
          return doc;
        })
        .catch(async (err) => {
          if (err.status === 409) {
            console.log('Conflict detected');
            return data;
          } else {
            console.log(err);
            return data;
          }
        });
    } else {
      return this.db.rel
        .save(type, data)
        .then((rdata: any) => {
          if (this.gsetting.logs_enabled) {
            this.log(data, data.rev ? 'updated' : 'added', type);
          }
          if (rdata && this.retrieve(rdata, type) && this.retrieveFirst(rdata, type)) {
            return this.retrieveFirst(rdata, type);
          } else {
            return rdata;
          }
        })
        .catch(async (err: any) => {
          if (err.status === 409) {
            console.log('Conflict detected', type);
            return data;
          } else {
            console.log(err);
            return data;
          }
        });
    }
  }

  clearLoadingDiv() {
    // Find all <ion-loading> elements
    var elements = document.querySelectorAll('ion-loading');

    // Loop through the NodeList and remove each element
    elements.forEach(function (element) {
      element.remove();
    });
  }

  getAttachment(type, id, attachmentId): Promise<any> {
    return this.db.rel.getAttachment(type, id, attachmentId).then(function (attachment) {
      return attachment;
    });
  }

  urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  getRevision(id, rev): Promise<any> {
    return this.db.get(id, { rev: rev }).then(function (doc) {
      return doc;
    });
  }

  getRemoteSettings(): Promise<any> {
    return this.http.post(`${this.db.server_url}/app/get`, { id: `setting_2_${this.gsetting.id}`, database: `${this.appinfo.product}$${this.gsetting.username}` }).toPromise();
  }

  // add missing settings and schema to the database
  async addMissingSettingsSchema() {
    let localsettings: any = await this.fetchLocalSettings().toPromise();
    let localschema: any = await this.fetchLocalSchema('');
    let currentschema = await this.get('schema', undefined);
    let currentsettings = await this.getAll('setting');
    let missingsettings = localsettings.filter((setting) => !currentsettings.some((s) => s.id === setting.id));
    missingsettings.map(async (setting) => {
      await this.update(setting, 'setting');
    });
    let missingschema = localschema.schema.filter((schema) => !currentschema.schema.some((s) => s.singular === schema.singular));
    missingschema.map((schema) => {
      currentschema.schema.push(schema);
    });
    if (missingschema.length > 0) {
      await this.update(currentschema, undefined);
      await this.db.setSchema(currentschema.schema);
    }
  }

  get(id, type): Promise<any> {
    if (type == undefined) {
      return this.db.get(id).then(function (doc) {
        return doc;
      });
    } else if (this.appinfo.schema_array.includes(type)) {
      return this.db.rel
        .find(type, id)
        .then(async (data: any) => {
          if (data[type + 's'].length == 0 && type == 'setting') {
            await this.addMissingSettingsSchema();
            if (id == 'schema') {
              location.reload();
            }
            return null;
          } else {
            return data && this.retrieve(data, type) ? this.retrieveFirst(data, type) : null;
          }
        })
        .catch((err: any) => {
          console.log(`cannot find ${id} in ${type}`);
        });
    } else {
      return new Promise(null);
    }
  }

  async getAll(type, options = {}): Promise<Array<any>> {
    if (this.data[type] != undefined) {
      // if data is already fetched
      if (Array.isArray(this.data[type])) {
        return this.data[type];
      } else if (this.data[type] instanceof BehaviorSubject) {
        return this.data[type].getValue();
      } else {
        return [];
      }
    } else if (this.db.rel) {
      return await this.db.rel
        .find(type, options)
        .then((data: any) => {
          let all = this.retrieve(data, type) ? this.retrieve(data, type) : [];
          if (type != 'chat') {
            this.data[type] = all.reverse();
          } else {
            this.data[type] = all;
            all.map((message) => {
              this.unreadCounter(message);
            });
          }
          return this.data[type];
        })
        .catch((err: any) => {
          /* this.setStructure(true).then(res => {
                    console.log('reset to avoid error');
                }); */
          console.log(err);
        });
    } else {
      console.log('db.rel is undefined');
    }
  }

  getAllRx(type, options = {}): Observable<Array<any>> {
    if (type == 'page') {
      return new Observable((observer) => {
        observer.next(this.pages);
      });
    } else {
      // {startkey: user_2_171, endkey: 172, limit: 2}
      return new Observable((observer) => {
        if (this.data[type] != undefined && this.appinfo.schema_array.includes(type)) {
          this.db
            .changes({
              live: true,
              since: 'now',
              conflicts: true,
              include_docs: true,
              attachments: true,
              binary: true,
            })
            .on('change', (change) => {
              if (change.id.substring(0, change.id.indexOf('_2_')) == type) {
                //only change if it is this element.
                this.handleChange(change).then((update) => {
                  if (update == true) {
                    observer.next(this.data[type]);
                  }
                });
              }
            });
          if (Array.isArray(this.data[type])) {
            observer.next(this.data[type]);
          } else {
            observer.next([]);
          }
        } else if (this.appinfo.schema_array.includes(type)) {
          if (this.db.rel == undefined) {
            return [];
          }
          return this.db.rel
            .find(type, options)
            .then((data: any) => {
              let all = this.retrieve(data, type) ? this.retrieve(data, type) : [];
              if (type != 'chat') {
                this.data[type] = all.reverse();
              } else {
                // map unread counters for chat
                this.data[type] = new BehaviorSubject<Array<any>>(all);
                all.map((message) => {
                  this.unreadCounter(message);
                });
              }
              this.db
                .changes({
                  live: true,
                  since: 'now',
                  include_docs: true,
                  conflicts: true,
                  attachments: true,
                  binary: true,
                })
                .on('change', (change) => {
                  if (change.id.substring(0, change.id.indexOf('_2_')) == type) {
                    this.handleChange(change).then((update) => {
                      if (update == true) {
                        observer.next(this.data[type]);
                      }
                    });
                  }
                });
              observer.next(this.data[type]);
            })
            .catch((err: any) => {
              console.log(err);
              observer.next(null);
            });
        } else {
          observer.next([]);
        }
      });
    }
  }

  handleChange(change) {
    return new Promise((resolve, reject) => {
      let type = change.id.substring(0, change.id.indexOf('_2_'));
      let changedDoc = null;
      let changedIndex = null;
      if (this.data[type] != undefined) {
        //check if it is from getAllRx()
        this.data[type].forEach((doc, index) => {
          if (type + '_2_' + doc.id == change.id) {
            changedDoc = doc;
            changedIndex = index;
            //A document was deleted
            if (change.deleted) {
              this.data[type].splice(changedIndex, 1);
              resolve(true);
            } else if (changedDoc) {
              change.doc = this.repair(change.doc, type);
              this.get(change.doc.id, type).then((res) => {
                this.data[type][changedIndex] = res;
                if (this.changes[type] != undefined) {
                  this.changes[type].next(res);
                }
                resolve(true);
              });
            } else {
              resolve(false);
            }
          }
        });
        //A document was added
        if (changedIndex == null && change.deleted == undefined) {
          change.doc = this.repair(change.doc, type);
          this.get(change.doc.id, type).then((res) => {
            if (type == 'chat') {
              if (this.data[type].getValue().findIndex((data) => data.id == res.id) == -1) {
                this.unreadCounter(res); //adjust counter
                this.data[type].next(this.data[type].getValue().concat(res));
                resolve(true);
              }
            } else {
              if (this.data[type].findIndex((data) => data.id == res.id) == -1) {
                this.data[type].unshift(res);
                resolve(true);
              }
            }
          });
        }
      } else {
        resolve(false);
      }
    });
  }

  repair(obj, type) {
    obj.data.id = obj._id.replace(type + '_2_', '');
    obj.data.rev = obj._rev;
    return obj.data;
  }

  unreadCounter(message, val = 1) {
    if (message.to == this.user.id && message.read != true) {
      //user
      if (this.unreadmessages[message.from] != undefined) {
        this.unreadmessages[message.from] += val;
      } else {
        this.unreadmessages[message.from] = 1;
      }
      this.unreadmessages.total += val;
    }
  }

  getLiveChanges(type): Observable<any> {
    if (this.changes[type] == undefined) {
      this.changes[type] = new BehaviorSubject<any>(<any>null);
    }
    return this.changes[type].asObservable();
  }

  lauth = environment.couchdb;

  remove(data: any, type: any): Promise<boolean> {
    return this.db.rel
      .del(type, data)
      .then((data: any) => {
        if (this.gsetting.logs_enabled) {
          this.log(data, 'deleted', type);
        }
        return data && data.deleted ? data.deleted : false;
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  removeRevision(id, rev) {
    return this.db
      .remove(id, rev)
      .then(function (doc) {
        console.log('revision removed');
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  removeId(id: any, type: any): Promise<boolean> {
    return this.db.rel
      .find(type, id)
      .then((data: any) => {
        let doc = data && this.retrieve(data, type) ? this.retrieveFirst(data, type) : null;
        return this.db.rel
          .del(type, doc)
          .then((data: any) => {
            return data && data.deleted ? data.deleted : false;
          })
          .catch((err: any) => {
            console.error(err);
          });
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  removeAll(type: any): Promise<any> {
    return this.getAll(type)
      .then((items: Array<any>) => {
        let promises: Array<any> = [];

        for (let item of items) {
          promises.push(this.remove(item, type));
        }
        return Promise.all(promises);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  retrieve(object, type) {
    return object[type + 's'];
  }

  retrieveFirst(object, type) {
    return object[type + 's'][0];
  }

  raz(dbname = this.db.name) {
    let db = new PouchDB(dbname, { skip_setup: true, auto_compaction: true });
    return db.destroy();
  }

  destroyLocalDB() {
    return this.db.destroy();
  }

  validateInstall(mode) {
    this.getAllRx(mode).subscribe(async (res) => {
      if (res == null || res.length < 3) {
        await this.initializeData(mode);
      } else {
        console.log(mode + ' preloaded');
      }
    });
  }

  async initializeData(mode) {
    await this.getJSON('./assets/data/' + mode + 's.json').subscribe(
      async (data) => {
        let entitys = data;
        for (let i = 0; i < entitys.length; i++) {
          await this.update(entitys[i], mode);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  //all databases

  getProjects(): Promise<any> {
    /* return PouchDB.allDbs().then(dbs => {
            dbs = dbs.filter(db => {
                let product = db.substr(0, db.indexOf('$'));
                return product == 'energyschemer'
            })
            return dbs;
        }); */
    return null;
  }

  async compact(dbname = this.db.name) {
    let data = {
      database: this.appinfo.product + '$' + this.gsetting.username,
    };
    let res: any = await this.http.post('https://sarutech.com/api/app/compact', data).toPromise();
    let db = new PouchDB(dbname, { skip_setup: true, auto_compaction: true });
    return db
      .compact()
      .then(function (info) {
        return info;
      })
      .catch(function (err) {
        console.log('Compaction Failed');
      });
  }

  async purge(dbname = this.db.name) {
    try {
      const db = new PouchDB(dbname, { skip_setup: true, auto_compaction: true });

      // Fetch all changes to identify deleted documents
      const changes = await db.changes({
        since: 0,
        include_docs: true,
      });

      // Extract deleted documents from changes feed
      const deletedDocs = changes.results
        .filter((change) => change.deleted)
        .map((change) => ({
          _id: change.id,
          _rev: change.changes[0].rev, // Use the correct revision
          _deleted: true, // Explicitly mark for deletion
        }));

      if (deletedDocs.length === 0) {
        console.log('No deleted documents to purge.');
        return [];
      }

      // Attempt bulk delete operation
      const results = await db.bulkDocs(deletedDocs);

      console.log('Purge results:', results);
      return results;
    } catch (err) {
      console.error('Error purging documents:', err);
      throw err;
    }
  }

  async extendLicense(plan, restrictions = undefined): Promise<boolean> {
    if (restrictions == undefined) {
      await this.updateRestrictions(plan);
    }
    if (plan != this.getPlan()) {
      this.gsetting.restrictions = restrictions;
      this.gsetting.plans.push(plan);
      if (plan != 'free' && plan != 'offline') {
        this.gsetting.online = true;
      }
      return this.update(this.gsetting, 'setting').then((setting) => {
        return Promise.resolve(true);
      });
    } else {
      return Promise.resolve(false);
    }
  }

  async updateUserAlternativeDB(): Promise<any> {
    try {
      const customer: any = await this.http.post('https://sarutech.com/api/app/getCustomer', { email: this.gsetting.email }).toPromise();
      if (!customer.data.databases) {
        customer.data.databases = {};
      }
      if (!customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`]) {
        customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`] = {};
      }
      customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`].alternative_db = this.gsetting.alternative_db;
      const updateResponse = await this.http.post('https://sarutech.com/api/app/updateCustomer', customer).toPromise();
      return updateResponse; // Return the result to the calling function
    } catch (error) {
      console.log('Error updating user:', error);
      return null; // Return null in case of an error
    }
  }

  async updateUserLicense(): Promise<any> {
    try {
      this.gsetting.signature = await this.getSignature();
      const customer: any = await this.http.post('https://sarutech.com/api/app/getCustomer', { email: this.gsetting.email }).toPromise();
      if (!customer.data.databases) {
        customer.data.databases = {};
      }
      if (!customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`]) {
        customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`] = {};
      }
      customer.data.databases[`${this.appinfo.product}$${this.gsetting.username}`].license = {
        username: this.gsetting.username,
        plans: this.gsetting.plans,
        startdate: this.gsetting.startdate,
        expiredate: this.gsetting.expiredate,
        restrictions: this.gsetting.restrictions,
        signature: this.gsetting.signature,
      };
      const updateResponse = await this.http.post('https://sarutech.com/api/app/updateCustomer', customer).toPromise();
      return updateResponse; // Return the result to the calling function
    } catch (error) {
      console.log('Error updating user:', error);
      return null; // Return null in case of an error
    }
  }

  async setExpire(value, type = 'months') {
    let date = new Date();
    if (type == 'days') {
      // add days to current date
      this.gsetting.expiredate = new Date(date.setDate(date.getDate() + value));
    } else if (type == 'months') {
      // Handle adding months properly
      const currentMonth = date.getMonth();
      const newMonth = currentMonth + value;
      date.setMonth(newMonth); // Automatically handles year overflow
      this.gsetting.expiredate = date;
      await this.updateUserLicense();

      /* if (new Date(this.gsetting.expiredate) > date) {
        //if there is still months left , just add to it. else start new license from today
        date = new Date(this.gsetting.expiredate);
      }
      this.gsetting.expiredate = new Date(date.setMonth(date.getMonth() + value)); */
    }
    return this.update(this.gsetting, 'setting').then((res) => {
      return null;
    });
  }

  canSync() {
    //Check if user can sync
    let fplan = this.gsetting.plans[this.gsetting.plans.length - 1];
    let plan = fplan.substring(fplan.lastIndexOf('.') + 1);
    if (plan != 'free' && plan != 'offline') {
      return true;
    } else {
      return false;
    }
  }

  async updateRestrictions(plan) {
    let product_id = `com.sarutech.${this.appinfo.product}.${plan}`;
    let product;
    if (this.online) {
      let data = {
        product: this.appinfo.product,
      };
      let res: any = await this.http.post('https://sarutech.com/api/app/getPricing', data).toPromise();
      product = res.find((aproduct: any) => aproduct.id == product_id);
    } else {
      let res: any = await this.getJSON('./assets/data/pc.json').toPromise();
      res.sort((a, b) => a.price - b.price);
      product = res.find((aproduct) => aproduct.id == product_id);
    }
    if (product && product.restrictions) {
      this.gsetting.restrictions = product?.restrictions;
      await this.update(this.gsetting, 'setting');
    }
  }

  getPlan() {
    //Check if user can sync .
    if (this.gsetting.plans != undefined) {
      let fplan = this.gsetting.plans[this.gsetting.plans.length - 1];
      let plan = fplan.substring(fplan.lastIndexOf('.') + 1);
      return plan;
    } else {
      setTimeout(() => {
        this.get(this.credentials.user_id, 'setting').then((setting) => {
          if (setting != undefined) {
            this.gsetting = setting;
            let fplan = this.gsetting.plans[this.gsetting.plans.length - 1];
            let plan = fplan.substring(fplan.lastIndexOf('.') + 1);
            return plan;
          } else {
            location.reload();
          }
        });
      }, 1000);
    }
  }

  onlineCheck$() {
    return merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
    /*  */
  }

  async transfertoDatabase(data, database, username, password, mode, remove) {
    let _data = {
      database: database,
      username: username,
      password: password,
      data: data,
      mode: mode,
      remove: remove,
    };
    this.http.post('https://sarutech.com/api/app/transferToDatabase', _data).subscribe((res: any) => {
      if (res?.status == 'success') {
        if (remove) {
          data.map((entity) => {
            this.remove(entity, mode);
          });
        }
      }
    });
  }

  checkTestDB() {
    let data = {
      database: `${this.appinfo.product}$${this.appinfo.product}test`,
    };
    this.http.post('https://sarutech.com/api/app/cloneSettings', data).subscribe(
      (res) => {
        console.log('test db available');
        this.testdb_available = true;
      },
      (err) => {
        this.testdb_available = false;
        console.log('no test db');
      }
    );
  }

  /* getDrug() {
    console.log(109, this.headers);
    this.headers = new HttpHeaders().append('Access-Control-Allow-Origin', '*');
    this.http.post('https://rxlist.com/rxl/api/search/triamcinolone', null, { headers: this.headers }).subscribe(
      (res) => {
        console.log(res);
      },
      (err) => {
        console.log('no data');
      }
    );
  } */

  async login() {
    let database = {
      username: this.gsetting.username,
      password: this.gsetting.password,
    };
    try {
      const res: any = await this.http
        .post('https://sarutech.com/couchdblogin/auth/login', database, {
          headers: this.headers,
        })
        .toPromise(); // Converts subscribe to a Promise for better async/await control.
      let credentials: any = res;
      if (Object.keys(credentials.userDBs).length === 0) {
        setTimeout(async () => {
          let headers = new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', `Bearer ${credentials.token}:${credentials.password}`);
          let data = {
            id: credentials.user_id,
            database: credentials.user_id,
          };
          await this.http.post('https://sarutech.com/couchdblogin/user/add-db', data, { headers }).toPromise(); // Ensures you wait for the user DB creation before retrying login.
          await this.login(); // Retry login after creating the DB.
        }, 2000);
      } else {
        //get remote plan
        await this.http
          .post('https://sarutech.com/api/app/get', { id: `setting_2_${this.gsetting.username}`, database: `${this.appinfo.product}$${this.gsetting.username}` })
          .toPromise()
          .then(
            async (res: any) => {
              // select settings with the latest expiredate
              if (new Date(res.data.expiredate) > new Date(this.gsetting.expiredate)) {
                this.gsetting = {
                  id: res._id,
                  rev: res._rev,
                  ...res.data,
                };
                await this.update(this.gsetting, 'setting');
              }
              if (this.gsetting.plans[this.gsetting.plans.length - 1] == 'free' || new Date() > new Date(this.gsetting.expiredate)) {
                this.presentToast('Your subscription has expired. Please renew to continue using the app.');
                this.router.navigateByUrl('/AddPaymentPage');
              } else {
                this.reconnect(credentials, database);
              }
            },
            (err) => {
              console.log(err);
              this.reconnect(credentials, database);
            }
          );
      }
    } catch (err) {
      console.log('Login failed', err);
      if (this.online && !this.triedregister) {
        this.triedregister = true;
        this.register(); // Retry register if login fails.
      } else {
        console.log('No Internet Connection');
      }
    }
  }

  async reconnect(credentials, database) {
    // Setting credentials before leaving the function
    credentials.online = true;
    credentials.skip_setup = false;
    credentials.password = database.password;
    localStorage.setItem(this.appinfo.product + '_credentials', JSON.stringify(credentials));
    console.log('Logged in Successfully');
    this.enableSyncing(credentials);

    let request = {
      type: 'returning',
      email: this.gsetting.email,
    };

    // Inform server someone is back again.
    await this.http.post('https://sarutech.com/api/app/rest', JSON.stringify(request)).toPromise(); // Ensures the API call completes before exiting.

    this.reconnected = true;
    console.log('Reconnected to server Successfully', this.connected, this.reconnected);
  }

  register() {
    let database = {
      username: this.gsetting.username,
      name: this.gsetting.company,
      password: this.gsetting.password,
      confirmPassword: this.gsetting.password,
      email: this.gsetting.email,
    };
    this.http
      .post('https://sarutech.com/couchdblogin/auth/register', database, {
        headers: this.headers,
      })
      .subscribe(
        (res) => {
          let details: any = res;
          let data = {
            id: details.user_id,
            database: this.appinfo.product,
          };
          let headers = new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', `Bearer ${details.token}:${details.password}`);
          setTimeout(async () => {
            this.http
              .post('https://sarutech.com/couchdblogin/user/add-db', data, {
                headers: headers,
              })
              .subscribe((res) => {
                this.login();
              });
          }, 2000);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  createZoomMeeting(meeting, customer = null): Promise<any> {
    return new Promise((resolve, reject) => {
      let accesstoken = this.gsetting.zoom.access_token;
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Authorization', 'Bearer ' + accesstoken);

      let request = {
        database: this.gsetting.username,
        product: this.appinfo.product,
        topic: `${this.gsetting.company} : ${this.user.fullname} Zoom Meeting ${customer != null ? 'with ' + customer.name : ''}`,
        type: 2, // Set to 3 for a recurring meeting with no fixed time
        start_time: moment.utc(meeting.date).format('YYYY-MM-DDTHH:mm:ss') + 'Z', // Send UTC time to server
        duration: this.gsetting.appointment_duration,
        password: Math.random().toString(20).substr(2, 6),
      };

      this.http
        .post('https://sarutech.com/api/app/create_meeting', request)
        .toPromise()
        .then(async (res: any) => {
          await this.loading.dismiss();

          meeting.zoom_meeting_id = res.id;
          meeting.zoom_meeting_password = res.password;
          meeting.topic = res.topic;
          meeting.host_id = res.host_id;
          meeting.start_time = moment(res.start_time).format('YYYY-MM-DDTHH:mm'); // Convert back to local time
          meeting.join_url = res.join_url;
          meeting.duration = res.duration;
          meeting.user = this.user.id;
          meeting.user_name = this.user.fullname;
          meeting.user_email = this.user.email;
          meeting.customer = customer != null ? customer.id : null;
          meeting.customer_name = customer != null ? customer.name : null;
          meeting.customer_email = customer != null ? customer.email : null;

          resolve(meeting);
        })
        .catch((error) => {
          this.loading.dismiss();
          reject(error);
        });
    });
  }

  findFilter(object, property, value) {
    //Search Filter
    if (object[property] != undefined) {
      if (isNaN(object[property]) && object[property].toLowerCase().indexOf(value) !== -1) {
        return true;
      } else if (!isNaN(object[property]) && object[property] == value) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  rename(name, language = this.language, type = 'input', item = null) {
    if (type == 'drug_dictionary') {
      item = item.replace(/_/g, ' ');
      let regex1 = new RegExp(item, 'i');
      name = name.replace(regex1, '');

      /* for (var i = 0; i == 9; i++) { //exclude numbers
                let regex = new RegExp(i + '. ', 'g');
                name = name.replace(regex, i + ')');
            } */
      name = name.replace(/\. /g, '.<br><br>');
      return name;
    } else if (name != undefined) {
      if (type == 'report') {
        // e.g remove name from requested_by_name
        name = name.replace('_name', '');
      }

      if (type == 'product' && name == 'amount') {
        name = 'selling_price';
      }
      if (type == 'product' && name == 'cost') {
        name = 'cost_price';
      }

      //replace key word without underscore because of database issues
      name = name.replace('radiology', 'radiology ');
      name = name.replace('laboratory', 'laboratory ');
      name = name.replace('zoom', 'zoom ');
      if (this.health_systems.includes(this.appinfo.base_product)) {
        // call customer as patient for pharmacy and hospital app
        name = name.replace('customer', 'patient');
      }
      if (this.appinfo.product == 'tailor') {
        // call customer as patient for pharmacy and hospital app
        name = name.replace('form', 'measurement');
      }
      if (name == 'medication') {
        // would like to use medication history, but silly pouchdb error when use an schema name with underscore, only usable when array is embedded. medication history is not embedded
        // name = 'medication_history';
      }
      if ((type == 'array' || type == 'form') && name.substr(name.length - 1) != 's' && name.indexOf('_') == -1) {
        name = pluralize(name);
      }
      if (type == 'date') {
        name = new Date(name).toLocaleString().slice(0, -3);
      }
      if (type == 'number') {
        name = name?.toLocaleString();
      }
      if (type == '@') {
        name = name.substring(1);
      }

      name = name.replace(/_/g, ' ');
      if (this.translations != undefined && this.translations[name.toLowerCase()] != undefined && this.language != 'en') {
        name = this.translations[name.toLowerCase()][language];
      } else if (this.translations != undefined && this.translations[name] != undefined && this.language != 'en') {
        name = this.translations[name][language]; // maintain case
      } else if (type == 's') {
        name = pluralize(name);
      } else if (this.language != 'en' && !this.untranslated.includes(name.toLowerCase())) {
        if (type == 'maintain_case') {
          this.untranslated.push(name);
        } else if (name && type != 'date') {
          this.untranslated.push(name.toLowerCase());
        }
      }
      return language != 'en' || type == 'title' ? this.titleCase(name) : name;
    } else {
      return '';
    }
  }

  titleCase(text) {
    if (text == undefined) {
      return text;
    } else {
      return text.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }

  isArray(str) {
    return Array.isArray(str);
  }

  getJSON(url): Observable<any> {
    return this.http.get(url);
  }

  getTranslations() {
    this.getJSON('./assets/data/translations.json').subscribe((data) => {
      this.translations = data;
    });
  }

  selectlanguage(language) {
    //when user has not logged in or created a database
    this.language = language;
    if (this.translations == undefined) {
      this.getTranslations();
    }
  }

  updateTranslations() {}

  saveTranslations() {
    this.getJSON('./assets/data/translations.json').subscribe((data) => {
      this.get('translations', undefined).then((res) => {
        res.data = data;
        this.update(res, undefined).then((as) => {
          console.log('updated');
        });
      });
    });
  }

  async initiateDB() {
    let credentials = {
      user_id: this.gsetting.username,
      password: this.gsetting.password,
      online: false,
      skip_setup: false,
    };
    let user = {
      id: this.gsetting.username,
      name: this.gsetting.company,
      email: this.gsetting.email,
      phonenumber: this.gsetting.phone,
      country: this.gsetting.country,
    };
    await this.initDB(credentials, true).then(async (res) => {
      await this.newSystemSetting(credentials, user).then((gsetting) => {
        this.gsetting = gsetting;
        this.appinfo.settings[0] = `setting_2_${this.gsetting.id}`;
      });
    });
  }

  sendEmailToUser(email, subject, message) {
    //sarutech email
    let data = {
      email: email,
      subject: subject,
      message: message,
    };
    this.http.post('https://sarutech.com/api/app/mail', data).subscribe((res) => {
      console.log('email sent');
    });
  }

  email(email, subject, body, ccEmail = '', name = '', ccName = '') {
    let uri = 'mailto:';
    if (email) {
      uri += name ? `${encodeURIComponent(name)} <${email}>` : email;
    }
    let queryParams = [];
    if (ccEmail) {
      let cc = ccName ? `${encodeURIComponent(ccName)} <${ccEmail}>` : ccEmail;
      queryParams.push(`cc=${cc}`);
    }
    if (subject) {
      queryParams.push(`subject=${encodeURIComponent(subject)}`);
    }
    if (body) {
      queryParams.push(`body=${encodeURIComponent(body)}`);
    }
    uri += queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    window.location.href = uri;
  }

  async sms(mobile, message) {
    if (!this.gsetting.vonage_api_key || !this.gsetting.vonage_api_secret) {
      this.presentToast('Please set up your Vonage API Key and Secret in the settings page', 'toast-danger');
      if (!this.demo) {
        this.router.navigateByUrl('/SystemSettingsPage');
      }
    } else {
      if (mobile) {
        this.loading = await this.loadingCtrl.create({
          message: `${this.rename('Please wait')}...`,
        });
        await this.loading.present();
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        let phone = mobile;
        if (!phone.startsWith(this.db.gsetting.sms.prefix)) {
          //if local
          phone = phone.charAt(0) == '0' ? phone.substring(1) : phone; //add prefix
          phone = this.db.gsetting.sms.prefix + phone;
        }
        let data = {
          from: this.gsetting.phone,
          to: phone,
          message: message,
          vonage_api_key: this.gsetting.vonage_api_key,
          vonage_api_secret: this.gsetting.vonage_api_secret,
        };
        this.http.post('https://sarutech.com/api/app/send_sms', data).subscribe(
          async (res) => {
            await this.loading.dismiss();
            this.presentToast(res['status'], 'toast-success');
          },
          async (err) => {
            console.log(err);
            await this.loading.dismiss();
            this.presentToast(err, 'toast-danger');
          }
        );
      } else {
        this.presentToast('Please enter a phone number for the customer in international format', 'toast-danger');
      }
    }
  }

  print(options: any = { name: 'Document', duplex: true }) {
    if (this.platform.is('cordova')) {
      this.printer.isAvailable().then(
        (success) => {
          this.printer.print(document.getElementById('print-content').innerHTML, options).then();
        },
        (error) => {
          console.log('printer not available');
        }
      );
    } else {
      if (typeof document.execCommand === 'function') {
        const success = document.execCommand('print', false, null);
        if (!success) {
          window.print();
        }
      } else {
        window.print();
      }
    }
  }

  async checkRestriction(mode, length) {
    if (this.gsetting.restrictions) {
      if (this.gsetting.restrictions[mode] == null) {
        return false;
      } else {
        return this.gsetting.restrictions[mode] <= length;
      }
    } else {
      await this.updateRestrictions(this.getPlan());
      if (this.gsetting.restrictions[mode] == null) {
        return false;
      } else {
        return this.gsetting.restrictions[mode] <= length;
      }
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  async presentToastAction(message, type = 'toast-normal', action = 'Reload') {
    const toast = await this.toastController.create({
      message: message,
      buttons: [
        {
          text: action,
          role: 'cancel',
          handler: () => {
            if (action == 'Reload') {
              window.location.reload();
            } else if (action == 'Repair') {
              this.repairLicense();
            }
          },
        },
      ],
      cssClass: type,
    });
    await toast.present();
  }

  downloadDoc(doc) {
    let name = doc.name || Math.round(new Date().getTime()).toString();
    let text = htmlToText(doc.content, {
      wordwrap: 130,
    });
    let html = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'></head><body>";
    var footer = '</body></html>';
    html = html + text + footer;

    //var data = new Blob([html], { type: 'application/msword;charset=utf-8' });
    var url = null;
    /* if (navigator.msSaveBlob) {
            url = navigator.msSaveBlob(data, name + '.doc');
        } else {
            url = window.URL.createObjectURL(data);
        } */
    url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    var tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.setAttribute('download', name + '.doc');
    tempLink.click();
    window.URL.revokeObjectURL(url);
  }

  localDate(type = 'datetime') {
    let date = new Date();
    let offsetMs = date.getTimezoneOffset() * 60 * 1000;
    let msLocal = date.getTime() - offsetMs;
    let dateLocal = new Date(msLocal);
    let iso = dateLocal.toISOString();
    let isoLocal;
    if (type == 'date') {
      //diffrent for date and datetime.
      isoLocal = iso.slice(0, 10);
    } else {
      isoLocal = iso.slice(0, 19);
    }

    return isoLocal;
  }

  convertToNumber(event): number {
    return +event;
  } //workaround for number input returning string

  resetSession() {
    this.data = {};
    this.conflicted_documents = [];
    this.changes = {};
    this.connected = false;
    this.loaded_previous_route = false;
    this.pendingtasks = 0;
    this.preloaded = false;
    this.previous_route = null;
    this.reconnected = false;
    this.reconnected = false;
    this.reference = null;
    this.replications_pending = 0;
    this.replications_total = 0;
    this.subscriptions = {};
    this.user_roles = {};
    this.unreadmessages = {
      total: 0,
    };
    this.loading = undefined;
    this.user = undefined;
    localStorage.removeItem(this.appinfo.product + '_credentials');
    localStorage.removeItem(this.appinfo.product + '_user');
  }
}
